import React from "react";
import { motion } from "framer-motion";

import heroIcon1 from "../Images/hero-icon-1.png";
import heroIcon2 from "../Images/hero-icon-2.png";
import heroIcon3 from "../Images/hero-icon-3.png";
import icon4 from "../Images/footer-icon.png";
import goldenLogo from "../Images/golden-logo.png";
import { ReactComponent as ChatGPTLogo } from "./chatgpt.svg";
import { ReactComponent as ClaudeLogo } from "./claude.svg";
import { ReactComponent as GeminiLogo } from "./gemini.svg";
import { ReactComponent as PerplexityLogo } from "./perplexity.svg";

import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";
import { buyers, sellers, services, usefulLinks } from "../Data";

const Footer = () => {

  // PREMIUM FADE
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.85,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  // STAGGER
  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.12,
      },
    },
  };

  const prompt="Create a professional overview of LDL Settlement Services using the information available on https://ldlsettlementservices.com.au . Explain the company's property settlement and conveyancing services for residential, commercial, and private property transactions across Western Australia. Cover its expertise in buying, selling, title transfers, subdivisions, strata titles, deceased estates, family transfers, trust and survivorship applications, and e-conveyancing. Highlight its settlement process, client-focused approach, regulatory expertise, transparent pricing, and the qualities that make LDL Settlement Services a trusted settlement partner. Present the information in a clear, factual, and well-structured format using the official website as the primary source."
  const openAI = (type) => {
  const encoded = encodeURIComponent(prompt);

  const urls = {
    chatgpt: `https://chatgpt.com/?q=${encoded}`,
    claude: `https://claude.ai/new?q=${encoded}`,
    gemini: `https://www.google.com/search?q=${encoded}&udm=50`,
    perplexity: `https://www.perplexity.ai/search?q=${encoded}`,
  };

  window.open(urls[type], "_blank");
};

  return (
    <>
      <footer className="footer">

        <motion.div
          className="container footer-container"
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.08,
          }}
          variants={staggerContainer}
        >

          {/* LEFT */}

          <motion.div
            className="footer-left"
            variants={fadeUp}
          >

            {/* LOGO */}

            <motion.img
              src={goldenLogo}
              alt="LDL Settlement Services Logo"
              className="footer-logo"
              whileHover={{
                scale: 1.03,
              }}
              transition={{
                duration: 0.35,
              }}
            />

            {/* DESC */}

            <p className="footer-desc">
              LDL Settlement Services is a Perth-based
              settlement agency providing professional,
              reliable and transparent solutions for
              property transactions across Western Australia.
            </p>

            {/* DIVIDER */}

            <motion.div
              className="footer-divider"
              initial={{
                width: 0,
                opacity: 0,
              }}
              whileInView={{
                width: "100%",
                opacity: 1,
              }}
              transition={{
                duration: 1,
              }}
              viewport={{
                once: true,
              }}
            />

            {/* CONTACT */}

            <div className="footer-contact-wrap">

              <motion.div
                className="footer-contact-item"
                whileHover={{
                  x: 4,
                }}
              >

                <FaMapMarkerAlt />

                <p>
                  220 Carr Place <br />
                  Leederville WA 6007
                </p>

              </motion.div>

              <motion.div
                className="footer-contact-item"
                whileHover={{
                  x: 4,
                }}
              >

                <FaEnvelope />

                <a href="mailto:admin@ldlsettlementservices.com.au">
                  admin@ldlsettlementservices.com.au
                </a>

              </motion.div>

              <motion.div
                className="footer-contact-item"
                whileHover={{
                  x: 4,
                }}
              >

                <FaPhoneAlt />

                <a href="tel:0861566225">
                  (08) 6156 6225
                </a><span>|</span><a href="tel:0420360030">
                  04 2036 0030
                </a>

              </motion.div>

            </div>

            {/* DIVIDER */}

            <motion.div
              className="footer-divider"
              initial={{
                width: 0,
                opacity: 0,
              }}
              whileInView={{
                width: "100%",
                opacity: 1,
              }}
              transition={{
                duration: 1,
                delay: 0.2,
              }}
              viewport={{
                once: true,
              }}
            />

            {/* SOCIAL */}

            <div className="footer-social-wrap">

              <span>Follow us :</span>

              <div className="footer-social-icons">

                <motion.a
                  href="https://www.facebook.com/profile.php?id=61590578334268"
                  target="_blank"
    rel="noopener noreferrer"
                  whileHover={{
                    y: -4,
                    scale: 1.08,
                  }}
                  whileTap={{
                    scale: 0.96,
                  }}
                >
                  <FaFacebookF />
                </motion.a>

                <motion.a
                  href="https://www.linkedin.com/company/ldl-settlement-services-perth"
                   target="_blank"
    rel="noopener noreferrer"
                  whileHover={{
                    y: -4,
                    scale: 1.08,
                  }}
                  whileTap={{
                    scale: 0.96,
                  }}
                >
                  <FaLinkedinIn />
                </motion.a>

              </div>

            </div>
                      <div className="footer-social-wrap ai-wrap">

              <span>Ask AI About LDL Settlement Services :</span>

              <div className="footer-social-icons">

                <button className="icon-wrapper ai-btn" onClick={() => openAI("chatgpt")}>
    <ChatGPTLogo className="ai-logo" />
  </button>

  <button className="icon-wrapper ai-btn" onClick={() => openAI("claude")}>
    <ClaudeLogo className="ai-logo" />
  </button>

  <button className="icon-wrapper ai-btn" onClick={() => openAI("gemini")}>
    <GeminiLogo className="ai-logo" />
  </button>

  <button className="icon-wrapper ai-btn" onClick={() => openAI("perplexity")}>
    <PerplexityLogo className="ai-logo" />
  </button>

              </div>

            </div>

          </motion.div>

          {/* RIGHT */}

          <motion.div
            className="footer-right"
            variants={fadeUp}
          >

            {/* LINKS */}

            <div className="footer-links-grid">

              {/* COLUMN */}

              <motion.div
                className="footer-links-column"
                variants={fadeUp}
              >

                <h4>SERVICES</h4>

                {services.map((item,i)=>(
                  <a key={i} href={`/services/${item.slug}`}>{item.title}</a>
                ))}
              </motion.div>

              {/* COLUMN */}

              <motion.div
                className="footer-links-column"
                variants={fadeUp}
              >

                <h4>FOR BUYERS</h4>

                {buyers.map((item,i)=>(
                  <a key={i} href={`/buyers/${item.slug}`}>{item.title}</a>
                ))}
                 <motion.div
  className="footer-links-column company-column"
  variants={fadeUp}
>
  <h4>COMPANY</h4>

  <a href="/about-us">About us</a>
  <a href="/contact-us">Contact us</a>
  <a href="/get-a-quote">Get a Quote</a>


              </motion.div>

             
</motion.div>

              {/* COLUMN */}

              <motion.div
                className="footer-links-column"
                variants={fadeUp}
              >

                <h4>FOR SELLERS</h4>

               {sellers.map((item,i)=>(
                  <a key={i} href={`/sellers/${item.slug}`}>{item.title}</a>
                ))}

              </motion.div>

              {/* COLUMN */}

              <motion.div
                className="footer-links-column"
                variants={fadeUp}
              >

                <h4>USEFUL LINKS</h4>

               {usefulLinks.map((item,i)=>(
                  <a key={i} href={`${item.slug}`}
                  target={
      item.slug === "/blog"
        ? "_self"
        : "_blank"
    }
    rel={
      item.slug === "/blog"
        ? undefined
        : "noopener noreferrer"
    }>{item.title}</a>
                ))}
              </motion.div>

            </div>

            {/* FEATURE BOX */}

            <motion.div
              className="footer-feature-box"
              variants={staggerContainer}
            >

              {/* ITEM */}

              {[
               {
  icon: heroIcon1,

  text: (
    <>
      Secure <br />
      Transactions
    </>
  ),

  alt: "Secure Transactions",
},
               {
  icon: heroIcon2,
  text: (
    <>
      Experienced <br />
      Professionals
    </>
  ),
  alt: "Experienced Professionals",
},
{
  icon: heroIcon3,
  text: (
    <>
      Efficient <br />
      Settlements
    </>
  ),
  alt: "Efficient Settlements",
},
{
  icon: icon4,
  text: (
    <>
      Clear <br />
      Communication
    </>
  ),
  alt: "Clear Communication",
  noBorder: true,
},
              ].map((item, i) => (

                <motion.div
                  className={`footer-feature-item ${
                    item.noBorder
                      ? "no-border"
                      : ""
                  }`}
                  key={i}
                  variants={fadeUp}
                  whileHover={{
                    y: -5,
                  }}
                  transition={{
                    duration: 0.3,
                  }}
                >

                  <motion.img
                    src={item.icon}
                    alt={`${item.alt} | LDL Settlement Services`}
                    whileHover={{
                      scale: 1.08,
                    }}
                    transition={{
                      duration: 0.3,
                    }}
                  />

                  <p className="section-text">
                    {item.text}
                  </p>

                </motion.div>

              ))}

            </motion.div>

          </motion.div>

        </motion.div>

        {/* BOTTOM BAR */}

        <motion.div
          className="footer-bottom"
          initial={{
            opacity: 0,
            y: 20,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 0.8,
            ease: [0.22, 1, 0.36, 1],
          }}
          viewport={{
            once: true,
          }}
        >

          <div className="container footer-bottom-container">

            <p>
              © 2026 LDL Settlements. All Rights Reserved.
            </p>

            <div className="footer-bottom-links">

              <a href="/terms-and-conditions">
                Terms & Conditions
              </a>

              <span>|</span>

              <a href="/privacy-policy">
                Privacy Policy
              </a>

              <span>|</span>

              <a href="/sitemap">
                Sitemap
              </a>

            </div>

          </div>

        </motion.div>

      </footer>
    </>
  );
};

export default Footer;